import roundBtcToSatoshi from 'utils/coins/BTC/roundBtcToSatoshi';
import divideNumberByPlaces from 'utils/common/divideNumberByPlaces';

interface IOptions {
  round?: boolean;
}

const formatBtcAmount = (value: number, options?: IOptions): string => {
  const { round = true } = options || {};

  const roundedValue = round ? roundBtcToSatoshi(+value) : +value || 0;

  return divideNumberByPlaces(roundedValue, '');
};

export default formatBtcAmount;
